import dayjs from "dayjs";
import { ListPage } from "../../components/ListPage";
import { DT_FORMATS } from "../../helpers/constants";
import type { GoodsReceipt } from "../../api-models";

export default function GRNsListPage() {
  return (
    <ListPage<GoodsReceipt>
      title="Goods Receipts"
      endpoint="/grns"
      searchPlaceholder="Search doc no or delivery note..."
      linkTo={(r) => `/procurement/grns/${r.id}`}
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "PO", render: (_, r) => r.po?.docNo },
        { title: "Supplier", render: (_, r) => r.supplier?.name },
        { title: "Warehouse", render: (_, r) => r.location?.name },
        { title: "Received at", dataIndex: "receivedAt", sorter: true, render: (v) => dayjs(v).format(DT_FORMATS.dateTime) },
      ]}
    />
  );
}
